module.exports = __webpack_public_path__ + "img/vertical_3_3_7005.f91aac6f.png";